import {
    ICofsClient,
    CofsClient
} from "../../../../../clients/cofs-client/cofs-client";

import { createContext, PropsWithChildren, useContext } from "react";

const CofsClientContext = createContext<ICofsClient>(new CofsClient());

export function useCofsClient(): ICofsClient {
    return useContext(CofsClientContext);
}

export type CofsClientProviderProps = PropsWithChildren<{
    readonly client: ICofsClient;
}>;

export const CofsClientProvider = ({
    client,
    children
}: CofsClientProviderProps) => {
    return (
        <CofsClientContext.Provider value={client}>
            {children}
        </CofsClientContext.Provider>
    );
};
